import { ArcElement, Chart as ChartJS, Legend, Tooltip } from "chart.js";
import { Pie } from "react-chartjs-2";

// Register needed Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

interface PieChartProps {
  total_data: any[];
  title: string;
}
export default function PieChart({ total_data, title }: PieChartProps) {
  const labels = total_data?.map((d: any) =>
    d.label === "" ? "Unknown" : d.label
  );
  const values = total_data?.map((d: any) => Number(d.value));

  const data = {
    labels,
    datasets: [
      {
        label: "Quotation Status",
        data: values,
        backgroundColor: ["#36A2EB", "#FF6384"], // adjust colors as you like
        borderColor: ["#fff", "#fff"],
        borderWidth: 1,
      },
    ],
  };

 const options = {
    plugins: {
      legend: {
        display: false, // ✅ hides legend
      },
    },
  };

  return (
    <div id="DashboardCard" className="dashboard-card ">
      <div className="flex justify-between border p-6 rounded-lg">
        <div>
          <span className="block text-gray-500 font- text-sm">{title}</span>
          <div className="text-900 font-medium text-3xl">
            <Pie data={data} options={options} />
          </div>
        </div>
      </div>
      <span className="text-500 text-sm"></span>
    </div>
  );
}
